import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "dialog-footer" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { style: {"display":"grid","grid-template-columns":"1fr 200px","column-gap":"20px"} }
const _hoisted_6 = { style: {"display":"grid","grid-template-columns":"1fr 200px","column-gap":"20px"} }
const _hoisted_7 = {
  key: 0,
  style: {"display":"flex","column-gap":"20px"}
}
const _hoisted_8 = {
  key: 1,
  style: {"display":"flex","column-gap":"20px"}
}
const _hoisted_9 = { style: {"display":"flex","flex-direction":"column","row-gap":"20px"} }
const _hoisted_10 = ["src"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { style: {"display":"flex","flex-direction":"column","row-gap":"8px","width":"100%"} }
const _hoisted_13 = { style: {"display":"grid","grid-template-columns":"auto 1fr auto","column-gap":"8px","align-items":"center","width":"100%"} }
const _hoisted_14 = { style: {"display":"flex","flex-wrap":"wrap","align-items":"center","column-gap":"8px","row-gap":"8px"} }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_PageHeader = _resolveComponent("PageHeader")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_step = _resolveComponent("el-step")!
  const _component_el_steps = _resolveComponent("el-steps")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_PageHeader, null, {
      default: _withCtx(() => [
        _cache[24] || (_cache[24] = _createElementVNode("h2", null, "Strutture configurate", -1)),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.selectedTermsFile = null; _ctx.showUploadTermsDialog = true})
        }, {
          default: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, {
              icon: "upload",
              style: {"margin-right":"8px"}
            }),
            _cache[22] || (_cache[22] = _createElementVNode("b", null, "Carica nuovi termini di servizio", -1))
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "success",
          onClick: _ctx.addOrganization
        }, {
          default: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, {
              icon: "plus",
              style: {"margin-right":"8px"}
            }),
            _cache[23] || (_cache[23] = _createElementVNode("b", null, "Configura nuova struttura", -1))
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: _ctx.items,
      stripe: "",
      border: "",
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "organizationId",
          label: "ID"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("b", null, _toDisplayString(scope.row.organizationId), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: "Nome"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("b", null, _toDisplayString(scope.row.name), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "wlextHost",
          label: "WLext Host"
        }),
        _createVNode(_component_el_table_column, {
          prop: "wlextOrganizationId",
          label: "WLext Organization ID"
        }),
        _createVNode(_component_el_table_column, {
          prop: "logo",
          label: "Logo"
        }, {
          default: _withCtx((scope) => [
            (scope.row.logo !== null)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: 'data:image/png;base64,' + scope.row.logo,
                  alt: "",
                  style: {"max-height":"45px"}
                }, null, 8, _hoisted_1))
              : (_openBlock(), _createElementBlock("span", _hoisted_2, "Nessun logo impostato"))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "Attiva" }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_switch, {
              modelValue: scope.row.isActive,
              "onUpdate:modelValue": ($event: any) => ((scope.row.isActive) = $event),
              onChange: ($event: any) => (_ctx.updateOrganizationIsActive(scope.row))
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "categories",
          label: "Categorie",
          align: "center",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_tag, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(scope.row.categories.length), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "usersAssociated",
          label: "Utenti associati",
          align: "center",
          width: "140"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_tag, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(scope.row.usersAssociated), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "lastMonthSignups",
          label: "Registrazioni (ultimi 30 giorni)",
          align: "center",
          width: "150"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_tag, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(scope.row.lastMonthSignups), 1)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_button, {
              style: {"margin-left":"8px"},
              size: "small",
              onClick: ($event: any) => (_ctx.showSignupsDetails(scope.row))
            }, {
              default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                _createTextVNode("Dettagli ", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "lastMonthDownloads",
          label: "Download (ultimi 30 giorni)",
          align: "center",
          width: "150"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_tag, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(scope.row.lastMonthDownloads), 1)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_button, {
              style: {"margin-left":"8px"},
              size: "small",
              onClick: ($event: any) => (_ctx.showDownloadsDetails(scope.row))
            }, {
              default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                _createTextVNode(" Dettagli ", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Operazioni",
          width: "140",
          align: "center"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_button_group, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: ($event: any) => (_ctx.editOrganization(scope.row))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, { icon: "pencil" })
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_button, {
                  type: "danger",
                  onClick: ($event: any) => (_ctx.deleteOrganization(scope.row))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, { icon: "trash" })
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, _ctx.isBusy]
    ]),
    (_ctx.showUploadTermsDialog)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 0,
          modelValue: _ctx.showUploadTermsDialog,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showUploadTermsDialog) = $event)),
          title: "Carica nuovi termini di servizio",
          width: "400",
          "close-on-click-modal": !_ctx.isDialogBusy,
          "close-on-press-escape": !_ctx.isDialogBusy
        }, {
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_button, {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showUploadTermsDialog = false))
              }, {
                default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                  _createTextVNode("Annulla", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "success",
                loading: _ctx.isDialogBusy,
                disabled: _ctx.selectedTermsFile === null,
                onClick: _ctx.uploadTerms
              }, {
                default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                  _createTextVNode(" Carica ", -1)
                ]))]),
                _: 1
              }, 8, ["loading", "disabled", "onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("input", {
              type: "file",
              onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.parseFile && _ctx.parseFile(...args)))
            }, null, 32)
          ]),
          _: 1
        }, 8, ["modelValue", "close-on-click-modal", "close-on-press-escape"]))
      : _createCommentVNode("", true),
    (_ctx.selectedOrganization !== null && _ctx.showDialog)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 1,
          modelValue: _ctx.showDialog,
          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.showDialog) = $event)),
          title: _ctx.selectedOrganization!.id === '' ? 'Configura nuova struttura' : 'Modifica struttura',
          width: "800"
        }, {
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_el_button, {
                onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.dialogActiveStep === 0 ? _ctx.showDialog = false : _ctx.dialogActiveStep -= 1))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.dialogActiveStep === 0 ? "Annulla" : "Indietro"), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "success",
                loading: _ctx.isDialogBusy,
                onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.dialogActiveStep === 2 ? _ctx.saveOrganization() : _ctx.continueSavingOrganization()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.dialogActiveStep === 2 ? "Salva" : "Continua"), 1)
                ]),
                _: 1
              }, 8, ["loading"])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_steps, {
              style: {"margin-bottom":"20px"},
              active: _ctx.dialogActiveStep,
              "finish-status": "success"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_step, { title: "Informazioni generali" }),
                _createVNode(_component_el_step, { title: "Configurazione categorie" }),
                _createVNode(_component_el_step, { title: "Disponibilità documenti" })
              ]),
              _: 1
            }, 8, ["active"]),
            (_ctx.dialogActiveStep === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_el_form, {
                    model: _ctx.selectedOrganization,
                    "label-position": "top"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_el_form_item, {
                          label: "Codice struttura",
                          required: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.selectedOrganization.organizationId,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedOrganization.organizationId) = $event)),
                              autocomplete: "off"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "Nome",
                          required: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.selectedOrganization.name,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedOrganization.name) = $event)),
                              autocomplete: "off"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_el_form_item, {
                          label: "WLext Host",
                          required: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.selectedOrganization.wlextHost,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedOrganization.wlextHost) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "WLext Organization ID" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.selectedOrganization.wlextOrganizationId,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedOrganization.wlextOrganizationId) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      (!_ctx.isEditing)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createVNode(_component_el_form_item, {
                              style: {"flex":"1"},
                              label: "Username",
                              required: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.selectedOrganizationAdmin.username,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedOrganizationAdmin.username) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              style: {"flex":"1"},
                              label: "Password",
                              required: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.selectedOrganizationAdmin.password,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedOrganizationAdmin.password) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createVNode(_component_el_form_item, {
                              style: {"flex":"1"},
                              label: "Username",
                              required: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.selectedOrganization.admin.username,
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedOrganization.admin.username) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              style: {"flex":"1"},
                              label: "Password"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_button, { onClick: _ctx.changePassword }, {
                                  default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                                    _createTextVNode(" Modifica password ", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            })
                          ])),
                      _createVNode(_component_el_form_item, { label: "Logo" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_9, [
                            (_ctx.selectedOrganization.logo !== null)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: 'data:image/png;base64,' + _ctx.selectedOrganization.logo,
                                  width: "300px",
                                  alt: ""
                                }, null, 8, _hoisted_10))
                              : _createCommentVNode("", true),
                            _createVNode(_component_el_button_group, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_button, { onClick: _ctx.loadImage }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.selectedOrganization.logo === null ?
                                            "Carica..." : "Modifica..."), 1)
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]),
                                (_ctx.selectedOrganization.logo !== null)
                                  ? (_openBlock(), _createBlock(_component_el_button, {
                                      key: 0,
                                      type: "danger",
                                      plain: "",
                                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.selectedOrganization.logo = null))
                                    }, {
                                      default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                                        _createTextVNode("Elimina ", -1)
                                      ]))]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }),
                            _createElementVNode("input", {
                              id: "input1",
                              style: {"display":"none"},
                              type: "file",
                              onChange: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.parseImage && _ctx.parseImage(...args)))
                            }, null, 32)
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "Testo personalizzato di invito" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            type: "textarea",
                            modelValue: _ctx.selectedOrganization.customInvitationText,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.selectedOrganization.customInvitationText) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model"])
                ]))
              : (_ctx.dialogActiveStep === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createVNode(_component_el_form, { "label-position": "top" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { label: "Seleziona le categorie documentali:" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("div", _hoisted_13, [
                                _createVNode(_component_el_tag, {
                                  round: "",
                                  size: "large"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("b", null, _toDisplayString(_ctx.categories.filter(x => x.selected).length), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_input, {
                                  placeholder: "Filtra le categorie...",
                                  modelValue: _ctx.categoryFilter,
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.categoryFilter) = $event)),
                                  clearable: ""
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_el_button_group, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_button, {
                                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.categories.forEach(x => x.selected = true)))
                                    }, {
                                      default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                                        _createTextVNode("Seleziona tutte ", -1)
                                      ]))]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_button, {
                                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.categories.forEach(x => x.selected = false)))
                                    }, {
                                      default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                                        _createTextVNode("Deseleziona tutte ", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_14, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
                                  return (_openBlock(), _createBlock(_component_el_checkbox, {
                                    key: category.id,
                                    modelValue: category.selected,
                                    "onUpdate:modelValue": ($event: any) => ((category.selected) = $event),
                                    label: category.name,
                                    size: "large",
                                    border: "",
                                    style: _normalizeStyle([{"margin":"0"}, { display: _ctx.getCategoryCheckboxStyle(category) }])
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "style"]))
                                }), 128))
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createVNode(_component_el_table, {
                      data: _ctx.categories.filter(x => x.selected),
                      stripe: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          prop: "name",
                          label: "Nome categoria"
                        }),
                        _createVNode(_component_el_table_column, { label: "Disponibilità documenti" }, {
                          default: _withCtx((scope) => [
                            _createVNode(_component_el_input_number, {
                              modelValue: scope.row.availabilityDays,
                              "onUpdate:modelValue": ($event: any) => ((scope.row.availabilityDays) = $event),
                              min: 0
                            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                            _cache[33] || (_cache[33] = _createTextVNode(" giorni ", -1)),
                            _cache[34] || (_cache[34] = _createElementVNode("div", null, [
                              _createElementVNode("small", null, [
                                _createElementVNode("i", null, "Inserire 0 per non limitare la disponibilità dei documenti")
                              ])
                            ], -1))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "Condizioni" }, {
                          default: _withCtx((scope) => [
                            _createVNode(_component_el_checkbox_group, {
                              modelValue: scope.row.conditions,
                              "onUpdate:modelValue": ($event: any) => ((scope.row.conditions) = $event)
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_checkbox, {
                                  label: "PREOSP",
                                  value: "PREOSP"
                                }),
                                _createVNode(_component_el_checkbox, {
                                  label: "PACC",
                                  value: "PACC"
                                }),
                                _createVNode(_component_el_checkbox, {
                                  label: "REP",
                                  value: "REP"
                                }),
                                _createVNode(_component_el_checkbox, {
                                  label: "AMB",
                                  value: "AMB"
                                }),
                                _createVNode(_component_el_checkbox, {
                                  label: "PS",
                                  value: "PS"
                                }),
                                _createVNode(_component_el_checkbox, {
                                  label: "LIS",
                                  value: "LIS"
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["data"])
                  ]))
          ]),
          _: 1
        }, 8, ["modelValue", "title"]))
      : _createCommentVNode("", true),
    (_ctx.selectedOrganization !== null && _ctx.showSignupsDetailsDialog)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 2,
          modelValue: _ctx.showSignupsDetailsDialog,
          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.showSignupsDetailsDialog) = $event)),
          width: "500",
          title: "Dettagli registrazioni"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table, {
              data: _ctx.selectedOrganization.signupsCounter,
              stripe: "",
              border: "",
              style: {"width":"100%"},
              "max-height": "500",
              "show-summary": "",
              "summary-method": _ctx.getSummaries
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, { label: "Data di riferimento" }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("b", null, _toDisplayString(scope.row.refDate), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "count",
                  label: "Registrazioni",
                  align: "center"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_tag, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(scope.row.count), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data", "summary-method"])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.selectedOrganization !== null && _ctx.showDownloadsDetailsDialog)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 3,
          modelValue: _ctx.showDownloadsDetailsDialog,
          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.showDownloadsDetailsDialog) = $event)),
          width: "500",
          title: "Dettagli download"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table, {
              data: _ctx.selectedOrganization.downloadsCounter,
              stripe: "",
              border: "",
              style: {"width":"100%"},
              "max-height": "500",
              "show-summary": "",
              "summary-method": _ctx.getSummaries
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, { label: "Data di riferimento" }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("b", null, _toDisplayString(scope.row.refDate), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "count",
                  label: "Download",
                  align: "center"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_tag, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(scope.row.count), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data", "summary-method"])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ]))
}